/**
 * 创建人：李珊
 * 时间：2020-12-10
 * 描述：关系下拉树组件 -- 多选
 */
import { Component, OnInit, Input, forwardRef, ElementRef, Injector, ApplicationRef, ComponentFactoryResolver, Output, EventEmitter, ViewChild, HostListener } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { KmsTreeMultiBoxComponent } from './kms-tree-multi-box/kms-tree-multi-box.component';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../kms.service';
export const EXE_COUNTER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => KmsTreeMultiComponent),
  multi: true
};

/**
 * 下拉多选框组件  kms-tree-multi
 */
@Component({
  selector: 'kms-tree-multi',
  templateUrl: './kms-tree-multi.component.html',
  styleUrls: ['./kms-tree-multi.component.css'],
  providers: [EXE_COUNTER_VALUE_ACCESSOR]
})
export class KmsTreeMultiComponent implements ControlValueAccessor,OnInit {

  /**
   * 是否显示清除按钮
   */
  @Input() clearData: boolean = true;    

  /**
   * 最多能选择的个数
   */
  @Input() maxSelectNum: number = 0;  

  /**
   * 下拉树组  [{id:""，text:""}]
   */
  @Input() datas: any[] = []; 

  /**
   * 是否禁止输入
   */
  @Input() disabled:Boolean = false

  /**
   * 下拉框的高度,不传默认根据内容自动设置
   */
  @Input() height: string = '250px';

  /**
   * 未选择时提示语
   */
  @Input() placeholder: string = '';

  /**
   * 是否有搜索框
   */
  @Input() isSearch: boolean = false;

  /**
   * 是否允许新增
   */
  @Input() addEnable: boolean = false;

  /**
   * 不允许选择的节点id
   */
  @Input() readonlySelfIds: any = [];

  /**
   * 同步默认打开到第几节点
   */
  @Input() openNode: number;

  /**
   * 是否通过所属概念组添加关系
   */
  @Input() conceptGroup: any = {
    sourceConceptId: '',
    sourceConceptName: '',
    targetConceptId:'',
    targetConceptName:''
  };

  /**
   * 是否显示下拉图标 （一般显示 当disabled为true 且isDropmenuIcon为false时 隐藏下拉图标）
   */
  @Input() isDropmenuIcon:  boolean = true;
  
  /**
   * 在有搜索框的前提下，如果搜索不到结果就有创建新选项的功能
   */
  @Input() createNewData:Boolean = false

  /**
   * 输出属性,点击添加'xxx'时，将要新建的数据抛出，业务方接受数据后要创建新标签且且将此新标签选中回填
   */
  @Output() addNewClick = new EventEmitter();

  /**
   * 选中数据
   */
  @Output() changeClick = new EventEmitter();

  /**
   * 输出属性,清空后,将将清空值传递给父组件
   */
  @Output() clearClick = new EventEmitter();
 
  /**
   * 输入框
   * @ignore
   */
  @ViewChild('input') input:ElementRef;

  /**
   * 显示文本值
   * @ignore
   */
  Text: string;   

  /**
   * 绑定值
   * @ignore
   */
  _id: string;  

  /**
   * @ignore
   */
  get Id(){
    return this._id;
  }

  /**
   * @ignore
   */
  set Id(value){
    this._id = value;
    this.propagateChange(this._id);
  }

  /**
   * @ignore
   */
  propagateChange = (_: any) => {};

  /**
   * 赋值参数
   * @ignore 
   */
  writeValue(value: string): void {
    if(value){ 
      // 如果有双向绑定的回显的数据
      //这里分割字符串的方法是以逗号 进行分割的,先把回显的id的字符串转化为数组
      this.selectedIds = value.split(",");
      //this.selectedIds 需要重新排序变成 this.selected，不然 this.selected 可能与 this.selectedText 顺序不一样， 导致点击input中右上角的删除时出错
      this.selected = this.datas.filter(x => this.isChecked(x.id)).map(x => x.id);
      this.selectedText = this.datas.filter(x => this.isChecked(x.id)).map(x => x.text);
      this.Id = value;
      this.Text = this.selectedText.join(",")
      // this.selectedText = [];
      // this.selectedIds.forEach(el => {
      //   let text = this.datas.filter(child => child.id == el)[0].text;
      //   this.selectedText.push(text)
      // })
      this.Id = value;
    }else{
      // 如果有双向绑定的回显的数据为空
      // 选中id为空
      this._id = "";
      // 选中Text为空
      this.Text = "";
      // 选中项数组为空
      this.selected = [];
      // 选中项文字数组为空
      this.selectedText = []; 
    }
    
    let timer1 = setTimeout(() => {
      // 在定时器中重新设置组件的高度
      if(this.el.nativeElement.querySelector(".sw-select-multi-cont") && this.el.nativeElement.querySelector(".inputbox")){
        let height1 = this.el.nativeElement.querySelector(".sw-select-multi-cont").offsetHeight
        let height2 = this.el.nativeElement.querySelector(".inputbox").offsetHeight
        if(height1 > height2){
          this.el.nativeElement.querySelector(".inputbox").style.height = height1 + 'px'
          this.el.nativeElement.querySelector(".form-control").style.height = height1 + 'px'
        }
      }
      clearTimeout(timer1)
    }, 200);
  }

  /**
   * @ignore
   */
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  /**
   * @ignore
   */
  registerOnTouched(fn: any): void {
  }

  /**
   * @ignore
   */
  setDisabledState?(isDisabled: boolean): void {
  }

  /**
   * 定位width 
   * @ignore
   */
  width:string

  /**
   * 定位left
   * @ignore
   */
  left:string

  /**
   * 定位top
   * @ignore
   */
  top:string

  /**
   * 唯一主键
   * @ignore
   */
  ids:string

  /**
   * @ignore
   */
  constructor(
    private injector: Injector,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private el :ElementRef,
    private kmsService: KmsService,
    private box:SwMassageBoxService) { }

  /**
   * @ignore
   */
  ngOnChanges() {
    //放置先获取到选择数据
    //后获取到数据集的问题 
    //判断数据集合 选择数据都不为空的情况下选中数据
    if (this.datas && this.datas.length>0) {
      this.selected = this.datas.filter(x => this.isChecked(x.id)).map(x => x.id);
      this.selectedText = this.datas.filter(x => this.isChecked(x.id)).map(x => x.text);
    }
  }

  /**
   * @ignore
   */
  ngOnInit() {
    this.ids = "select" + Math.random().toString().split(".")[1];
  }
 
  /**
   * @ignore
   * 展现关闭下拉
   */
  dropdown: boolean = false;

  /**
   *  @ignore
   *  展现关闭下拉
   */
  swSelectMultiComponentRef:any;
  /**
   * 打开下拉框
   * @ignore
   */
  open(event){ 
    const com = document.createElement(KmsTreeMultiBoxComponent.name);
    //创建动态组件
    const factory = this.componentFactoryResolver.resolveComponentFactory(KmsTreeMultiBoxComponent);
    this.swSelectMultiComponentRef = factory.create(this.injector, [], com);
    this.applicationRef.attachView(this.swSelectMultiComponentRef.hostView);
    // 打开下拉框
    this.dropdown = true; 
    // 向动态创建的组件传递参数
    this.swSelectMultiComponentRef.instance["ids"] = this.ids;
    // 向动态创建的组件传递参数
    this.swSelectMultiComponentRef.instance["elem"] = this.el;
    // 向动态创建的组件传递参数
    this.swSelectMultiComponentRef.instance["dropdown"] = this.dropdown;
    // 向动态创建的组件传递参数
    this.swSelectMultiComponentRef.instance["height"] = this.height;
    // 向动态创建的组件传递参数
    this.swSelectMultiComponentRef.instance["selected"] = this.selected;
    // 向动态创建的组件传递参数
    this.swSelectMultiComponentRef.instance["selectedText"] = this.selectedText;
    // 向动态创建的组件传递参数
    this.swSelectMultiComponentRef.instance["isSearch"] = this.isSearch;
    // 向动态创建的组件传递参数
    this.swSelectMultiComponentRef.instance["addEnable"] = this.addEnable;
    // 向动态创建的组件传递参数
    this.swSelectMultiComponentRef.instance["readonlySelfIds"] = this.readonlySelfIds;
    // 向动态创建的组件传递参数
    this.swSelectMultiComponentRef.instance["openNode"] = this.openNode;
    // 向动态创建的组件传递参数
    this.swSelectMultiComponentRef.instance["conceptGroup"] = this.conceptGroup;
    // 向动态创建的组件传递参数
    this.swSelectMultiComponentRef.instance["datas"] = this.datas;
    // 向动态创建的组件传递参数
    this.swSelectMultiComponentRef.instance["maxSelectNum"] = this.maxSelectNum;
    // 向动态创建的组件传递参数
    this.swSelectMultiComponentRef.instance["createNewData"] = this.createNewData;
    // 向动态创建的组件传递回调函数
    this.swSelectMultiComponentRef.instance["closeSelect"].subscribe(data => {
      try {
        // 失去焦点
        this.input.nativeElement.blur()
        // 移除元素
        document.body.removeChild(com);
        this.applicationRef.detachView(this.swSelectMultiComponentRef.hostView);
        // 销毁组件
        this.swSelectMultiComponentRef.destroy()
      } catch (e) { }

    });

    this.swSelectMultiComponentRef.instance["changeClick"].subscribe(data => {
      try {
        // 有参数就触发此事件
        this.updateSelected(data.action,data.item)
      } catch (e) { }

    });

    // 将组件加到dom中去显示
    document.body.appendChild(com);
    
  }
  /**
   * 关闭下拉框
   * @ignore
   */
  close() {
    // this.dropdown = false; 
    this.swSelectMultiComponentRef.instance.close()
  }
  /**
   * 选中下拉框数据
   * @ignore
   */
  // onVoted(e, item){
  //   const action = this.isChecked(item.id)?'remove':'add';
  //   this.updateSelected(action,item);
  //   return false; //阻止事件冒泡而关闭下拉框
  // }

  /**
   * 父组件要回显的id, 需要重新排序才能成为 组件选中的id : selected
   * @ignore
   */
  selectedIds = [];  

  /**
   * 选中的id
   * @ignore
   */
  selected = [];  

  /**
   * 选中的文本
   * @ignore
   */
  selectedText = [];  

  /**
   * 判断点击的数据是新增还是删除 ，做出相对的处理
   * @param action  添加还是删除
   * @param item  选中的数据
   * @ignore
   */
  private updateSelected(action, item){
    //新增添加点击的数据
    if(action == 'add' && this.selected.findIndex(value => value == item.id) == -1){
      this.selected.push(item.id);
      this.selectedText.push(item.text);
    }
    // 替换之前选择的数据
    if (action == 'replace') {
      //如果有选中标签个数限制，那么在新增的时候，超过个数就不能新增了
      if (this.maxSelectNum && this.selected.length >= this.maxSelectNum) {
        this.box.danger('已达到最大选中数')
        return
      }
      if(item.length>0){
        this.selected = [];
        this.selectedText = [];
        item.forEach(child => {
          this.selected.push(child.id);
          this.selectedText.push(child.text);
        })
      }else{
        this.selected = [];
        this.selectedText = [];
      }
    }
    //删除 就删除对应的数据
    if(action == "remove" && this.selected.findIndex(value => value == item.id) != -1){
      this.selectedText.splice(this.selected.findIndex(value => value == item.id), 1);
      this.selected.splice(this.selected.findIndex(value => value == item.id), 1);
    }
    //将选择的数据凭借起来
    if(this.selectedText.length != 0){
      this.Text = this.selectedText.join(',');
      this.Id = this.selected.join(',');
    }else{
      this.Text = "";
      this.Id = "";
    }

    this.changeClick.emit(this.selected);

    //记录上一次改变时组件的高度
    let preHeight = this.el.nativeElement.querySelector(".inputbox").offsetHeight
    //多选结果多了,超过一行,就将输入框变高
    let timer2 = setTimeout(() => {
      let height1
      if(this.selectedText.length){
        height1 = this.el.nativeElement.querySelector(".sw-select-multi-cont").offsetHeight
        
      } else {
        //没有 div.sw-select-multi-cont 
        height1 = 34
      }
      this.el.nativeElement.querySelector(".inputbox").style.height = height1 + 'px'
      this.el.nativeElement.querySelector(".form-control").style.height = height1 + 'px'
      if(!this.selectedText.length){  //减少的时候,如果最后没有选中项,要有最小的高度
        this.el.nativeElement.querySelector(".inputbox").style.height = preHeight + 'px'
        this.el.nativeElement.querySelector(".form-control").style.height = preHeight + 'px'
      }
      clearTimeout(timer2)
    }, 0);
  }

  /**
   * 判断是否选中数据
   * @param id  选中的id
   * @ignore
   */
  isChecked(id){
    return this.selectedIds.findIndex(value => value == id) >= 0;
  }

  /**
   * 每个选择数据的单个删除事件
   * @param text 删除的对象
   * @ignore
   */
  closetigger(event,text: string) {
    event.stopPropagation()
    for (let item of this.datas) {
      if (item.text === text)
        this.updateSelected('remove', item);
    }
  }

  /**
   * 清空事件
   * @ignore
   */
  clearselect(){
    // 清空选中项
    this.selected = [];
    // 清空选中文本
    this.selectedText = []; 
    this.Text = "";
    this.Id = "";
    // 抛出空数组
    this.clearClick.emit([])
    //清空所有的选中项之后,将组件高度还原
    this.el.nativeElement.querySelector(".sw-select-multi-cont").style.height = '0px'
    this.el.nativeElement.querySelector(".inputbox").style.height = '34px'
    this.el.nativeElement.querySelector(".form-control").style.height = '34px'
  }

  //点击右侧三角图标
  switchDropmenu(event){
    event.stopPropagation(); //禁止冒泡
    if(!this.dropdown){ 
      //如果this.dropdown 为false,说明没有展开下拉框,此时需要展开下拉框
      this.input.nativeElement.focus()
    }  else {
      //此时已经自动触发了 blur 事件,下拉框已销毁, 需要将 this.dropdown 设置为false
      this.dropdown = false
    }
  }

  clickFocus(){
    this.input.nativeElement.focus()
  }

  // // 查询关系树数据
  // getTreeData(state) {
  //   // 需判断conceptGroup的值，有值时通过conceptGroup查询
  //   this.kmsService.getRelationDirectoryList('').subscribe(
  //       data => {
  //           if (data.code == '200') {
  //               if (!data.data) {
  //                 this.datas = []
  //                 return;
  //               }
  //               this.datas = data.data;
  //               for (let i = 0; i < this.datas.length; i++) {
  //                   if (!this.datas[i].parentId) {
  //                       this.datas[i].parentId = '0';
  //                       this.datas[i].pid = '0';
  //                   }
  //               }
  //               // for (let i = 0; i < this.datas.length; i++) {
  //               //   this.datas[i].id = this.datas[i].relationName;
  //               //   this.datas[i].text = this.datas[i].relationId;
  //               // }
  //               // 需要设置回显
  //               if(state){
  //                 //this.selectedIds 需要重新排序变成 this.selected，不然 this.selected 可能与 this.selectedText 顺序不一样， 导致点击input中右上角的删除时出错
  //                 this.selected = this.datas.filter(x => this.isChecked(x.id)).map(x => x.id);
  //                 this.selectedText = this.datas.filter(x => this.isChecked(x.id)).map(x => x.text);
  //                 this.Text = this.selectedText.join(",")
  //               }
  //           }
  //       }
  //     );
  // }
}
